<template>
  <div>
    <imgHeader imgUrl="/img/6党团活动-banner.jpg" />
    <NewsCom :title="$t('public.partyTitle')" />
  </div>
</template>

<script>
  import NewsCom from '../../components/NewsCom.vue'
  export default {
    name: 'Activity',
    components: {
      NewsCom,
    },
  }
</script>

<style></style>
